import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/dist/query";
import { sideNavLayoutSlice } from "./slices";
import apiSlice from "src/services/ApiSlice";
import { fileExplorerSlice } from "src/services/FileExplorer";
import { authMiddleware } from "src/middlewares/authMiddleware";
import UserSlice from "./slices/UserSlice";
import FranchiseSlice from "./slices/FranchiseSlice";
import AdvancePaymentSlice from "./slices/AdvancePaymentSlice";
import PaymentSlice from "./slices/PaymentSlice";
import ConfigurationLayoutSlice from "./slices/ConfigurationLayoutSlice";
import PaymentModeSlice from "./slices/PaymentModeSlice";
import CourseSlice from "./slices/CourseSlice";
import LevelSlice from "./slices/LevelSlice";
import SubjectSlice from "./slices/SubjectSlice";
import FacultySlice from "./slices/FacultySlice";
import ModeSlice from "./slices/ModeSlice";
import AuthSlice from "./slices/AuthSlice";
import OfflineOrderSlice from "./slices/OfflineOrderSlice";
import CourseTypeSlice from "./slices/CourseTypeSlice";
import AttemptSlice from "./slices/AttemptSlice";
import DashboardSlice from "./slices/DashboardSlice";
import FranchiseOrderSlice from "./slices/FranchiseOrderSlice";
import FranchiseLedgerSlice from "./slices/FranchiseLedgerSlice";
import BookSlice from "./slices/BookSlice";
import ExpenseCategoriesSlice from "./slices/ExpenseCategoriesSlice";
import ProductManagementSlice from "./slices/ProductManagementSlice";
import DrawerSlice from "./slices/DrawerSlice";
import StudentSlice from "./slices/StudentSlice";
import FuturePurchaseSlice from "./slices/FuturePurchaseSlice";
import FuturePurchaseFollowupSlice  from "./slices/FuturePurchaseFollowupSlice";
import FuturePurchaseLedgerSlice from "./slices/FuturePurchaseLedgerSlice";
import DueAmountSlice from "./slices/Dashboard2Slice";
import UserRoleSlice from "./slices/UserRoleSlice";
import StudentOrderSlice from "./slices/StudentOrderSlice";
import StudentLedgerSlice from "./slices/StudentLedgerSlice";
import DuesSlice from "./slices/DuesSlice";
const store = configureStore({
  reducer: {
    sideNavLayout: sideNavLayoutSlice,
    auth: AuthSlice,
    user: UserSlice,
    franchise : FranchiseSlice,
    advancePayment : AdvancePaymentSlice,
    payment : PaymentSlice,
    dues : DuesSlice,
    configurationLayout : ConfigurationLayoutSlice,
    paymentMode : PaymentModeSlice,
    dueAmount:DueAmountSlice,
    book : BookSlice,
    userRole : UserRoleSlice,
    expenseCategories : ExpenseCategoriesSlice,
    productManagement : ProductManagementSlice,
    futurePurchase : FuturePurchaseSlice,
    followupNotes : FuturePurchaseFollowupSlice,
    futurePurchaseLedger : FuturePurchaseLedgerSlice,
    drower: DrawerSlice,
    course : CourseSlice,
    level : LevelSlice, 
    subject : SubjectSlice,
    student :StudentSlice,
    faculty : FacultySlice,
    mode : ModeSlice,
    offlineOrder : OfflineOrderSlice,
    courseType : CourseTypeSlice,
    attempt : AttemptSlice,
    dashboard:DashboardSlice,
    studentOrder:StudentOrderSlice,
    studentLedger:StudentLedgerSlice,
    franchiseOrder : FranchiseOrderSlice,
    franchiseLedger : FranchiseLedgerSlice,
    [apiSlice.reducerPath]: apiSlice.reducer,
    [fileExplorerSlice.reducerPath]: fileExplorerSlice.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat([
      authMiddleware,
      apiSlice.middleware,
      fileExplorerSlice.middleware,
    ]),
});

setupListeners(store.dispatch);
export default store;
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
